export enum NotificationChannel {
    email = 'email',
    telegram = 'telegram',
    discord = 'discord',
}

export type NotificationTopicSlug = string;

export interface NotificationTokenPair {
    access_token: string;
    refresh_token: string;
    token_type: 'Bearer';
    access_expires_at: string;
    refresh_expires_at: string;
}

export interface NotificationAuthError {
    error:
        | 'invalid_transaction'
        | 'unknown_challenge'
        | 'challenge_consumed'
        | 'challenge_expired'
        | 'invalid_challenge'
        | 'account_mismatch'
        | 'domain_mismatch'
        | 'bad_signature'
        | 'insufficient_signatures'
        | 'invalid_token'
        | 'token_reused'
        | 'token_expired'
        | 'account_gone';
    detail: string;
}

export interface NotificationChannelBinding {
    id: number;
    channel: NotificationChannel;
    address: string;
    display_name: string | null;
    is_active: boolean;
    verified_at: string | null;
    topics: NotificationTopicSlug[];
}

export interface NotificationTopic {
    slug: NotificationTopicSlug;
    title: string;
}

export interface NotificationFeedItemFieldSegment {
    text: string;
    strikethrough: boolean;
    // Segment-level link (e.g. the market name in a rewards row).
    href?: string | null;
}

export interface NotificationFeedItemField {
    label: string;
    value: string;
    href: string | null;
    strikethrough: boolean;
    // Rich value: lets a part of the value (e.g. the previous amount in
    // "old → new") render struck through.
    segments?: NotificationFeedItemFieldSegment[] | null;
}

export interface NotificationFeedItemSummaryPart {
    text: string;
    href: string | null;
}

export interface NotificationFeedItem {
    id: number;
    event_type: NotificationTopicSlug;
    title: string;
    summary: string;
    // Rich summary: lets parts of the summary (e.g. token names) render as links.
    summary_parts?: NotificationFeedItemSummaryPart[] | null;
    fields?: NotificationFeedItemField[];
    primary_link: { label: string; url: string } | null;
    created_at: string;
    unread: boolean;
}

export interface NotificationFeed {
    enabled: boolean;
    unread: number;
    items: NotificationFeedItem[];
}

export interface NotificationChannelsReplaceEntry {
    channel: NotificationChannel;
    address: string;
    topics: NotificationTopicSlug[];
}
